import { Spin } from 'antd';
import React from 'react';
import './Spinner.less';

const Spinner = () => {
  return (
    <div className="center">
      <Spin />
    </div>
  );
};

export default Spinner;
